// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__l4blM","root":"App_root__dAKE6"};